<article *ngIf="messages.length > 0" class="w-fit fixed top-0 z-5 right-0 bg-transparent mt-2 sm:mt-8 ci-main-padding">
  <section *ngIf="showInformation" class="fadeinright animation-duration-400 relative">
    <section class="w-22rem md:w-27rem local-message-gallery ci-bg-glass border-round-xl px-2 pt-2 px-3 shadow-3">
      <swiper-container class="w-full" autoplay-delay="10000" #swiper pagination="true">
        <swiper-slide class="w-full" *ngFor="let message of messages">
          <section class="mb-5">
            <section class="w-full flex align-items-center justify-content-between mb-2 sm:mb-3">
              <section class="flex align-items-center gap-2">
                <i *ngIf="message?.iconClass" class="{{message?.iconClass}} text-sm sm:text-lg ci-txt--white"></i>

                <p class="text-sm sm:text-lg font-semibold ci-txt--white">
                  {{message?.title}}
                </p>
              </section>

              <section *ngIf="message?.actionLabel" (click)="openAction(message)"
                class="w-fit ci-bg--black px-2 border-round-lg flex justify-content-center align-items-center cursor-pointer">
                <small class="ci-txt--white" style="padding: 2px 0 3px 0;">
                  {{message?.actionLabel}}
                </small>
              </section>
            </section>

            <small class="ci-txt--white text-sm sm:text-lg font-italic">
              <marquee behavior="scroll" direction="left">
                {{message?.text}}
              </marquee>
            </small>
          </section>
        </swiper-slide>
      </swiper-container>
    </section>

    <section
      class="w-1rem h-1rem flex align-items-center justify-content-center h-fit absolute top-0 right-0 bg-white -mt-1 -mr-1 border-circle cursor-pointer"
      (click)="toggle(true)">
      <i class="bi bi-x-circle-fill ci-txt--cherry text-xl"></i>
    </section>
  </section>

  <section *ngIf="!showInformation" class="w-full flex justify-content-end mt-3 fadeinright animation-duration-400">
    <section class="w-1rem h-1rem ci-bg-glass cursor-pointer p-4 shadow-2 flex align-items-center justify-content-center 
           relative border-circle md:border-round-xl md:w-auto md:gap-2" pTooltip="Avisos" tooltipPosition="left"
      tooltipStyleClass="ci-tooltip--yellow" (click)="toggle(true)">
      <i class="bi bi-bell ci-txt--white text-2xl" [ngClass]="{'shake': isShaking, 'ci-txt--yellow': hasChanges}"></i>
      <span class="hidden md:inline text-white"> Comunicados </span>

      <section *ngIf="hasChanges" class="absolute top-0 right-0 ci-bg--yellow border-circle"
        style="width: 12px; height: 12px;">
      </section>
    </section>
  </section>

  <section class="w-full flex justify-content-end mt-3 fadeinright animation-duration-400">
    <section (click)="openLinesModal()" class="w-1rem h-1rem ci-bg-glass cursor-pointer p-4 shadow-2 flex align-items-center justify-content-center 
           relative border-circle md:border-round-xl md:w-auto md:gap-2" pTooltip="Rutas" tooltipPosition="left"
      tooltipStyleClass="ci-tooltip--yellow">
      <i class="bi bi-truck-front ci-txt--white text-2xl"></i>
      <span class="hidden md:inline text-white"> Transporte </span>
    </section>
  </section>

  <section class="w-full flex justify-content-end mt-3 fadeinright animation-duration-400">
    <section class="w-1rem h-1rem ci-bg-glass cursor-pointer p-4 shadow-2 flex align-items-center justify-content-center 
           relative border-circle md:border-round-xl md:w-auto md:gap-2" pTooltip="Mapa" tooltipPosition="left"
      tooltipStyleClass="ci-tooltip--yellow" [routerLink]="['/map']">
      <i class="bi bi-map ci-txt--white text-2xl"></i>
      <span class="hidden md:inline text-white"> Ciudad </span>
    </section>
  </section>
</article>

<style>
  @keyframes shake {
    0% {
      transform: rotate(0);
    }

    15% {
      transform: rotate(-10deg);
    }

    30% {
      transform: rotate(10deg);
    }

    45% {
      transform: rotate(-10deg);
    }

    60% {
      transform: rotate(10deg);
    }

    75% {
      transform: rotate(-5deg);
    }

    100% {
      transform: rotate(0);
    }
  }

  .shake {
    animation: shake 1s infinite;
  }
</style>